import { ApiProduct, ApiSpecialsProduct } from '../../../types';
import { ProductBoxGeneratePrice } from '../ProductBoxSpecialPrice/ProductBoxGeneratePrice';
import '../ProductListing.css';

type ProductListingProps = {
	products: (ApiProduct | ApiSpecialsProduct)[];
	highlightId?: number | null;
	className?: string;
	specialPriceOnClick: (action: 'accept' | 'generate', product: ApiProduct) => void;
};

export const GenerateSpecialPriceProductListing = ({
	products,
	highlightId,
	className = '',
	specialPriceOnClick,
}: ProductListingProps): JSX.Element | null => {
	const isSpecialProduct = (product: ApiProduct | ApiSpecialsProduct): product is ApiSpecialsProduct => {
		return 'newPrice' in product;
	};

	return (
		<div className={'product-listing ' + className}>
			{products.map((p) => {
				const isSpecialPriceProduct = isSpecialProduct(p);
				return (
					<ProductBoxGeneratePrice
						highlight={isSpecialPriceProduct ? p.product.id === highlightId : p.id === highlightId}
						product={isSpecialPriceProduct ? p.product : p}
						key={isSpecialPriceProduct ? p.productId : p.id}
						onClick={specialPriceOnClick}
						displayLockedUnitil={false}
					/>
				);
			})}
		</div>
	);
};
